const fetch = global.fetch ? global.fetch : require('isomorphic-fetch');

export default fetch;
